import { z } from "zod";

export const adminSyncTaskSchema = z.object({
  id: z.string().uuid(),
  kind: z.enum(["sync", "seller_sales", "seller_realtime", "auxiliary"]),
  jobType: z.string(),
  reportType: z.string().nullable(),
  shops: z.array(
    z.object({
      id: z.string().uuid(),
      name: z.string().nullable(),
      marketplaceId: z.string().nullable(),
      marketplaceName: z.string().nullable(),
    }),
  ),
  workspaceId: z.string().uuid().nullable(),
  workspaceName: z.string().nullable(),
  status: z.enum(["queued", "running", "success", "failed", "cancelled", "skipped", "partial"]),
  phase: z
    .enum([
      "queued",
      "requesting",
      "polling",
      "processing",
      "catalog",
      "inventory",
      "retrying",
      "executing",
      "listing",
      "fba",
    ])
    .nullable(),
  startDate: z.string().date().nullable(),
  endDate: z.string().date().nullable(),
  createdAt: z.string().datetime(),
  startedAt: z.string().datetime().nullable(),
  finishedAt: z.string().datetime().nullable(),
  errorCode: z.string().nullable(),
});

export const adminSyncTasksResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    tasks: z.array(adminSyncTaskSchema),
    pagination: z.object({
      page: z.number().int().positive(),
      pageSize: z.number().int().positive(),
      total: z.number().int().nonnegative(),
      hasMore: z.boolean(),
    }),
    coverage: z.object({ complete: z.boolean(), missing: z.array(z.string()) }),
  }),
});

export type AdminSyncTask = z.infer<typeof adminSyncTaskSchema>;
export type AdminSyncTasksResponse = z.infer<typeof adminSyncTasksResponseSchema>;
